import React from 'react'
import BackgroundElementImg from './BackgroundElementImg';

const BackgroundElementPoster = ({
    poster,
    cssClassesPoster,
    posterSettings,
    fallbackInUse,
    setFallback
}) => (
    poster ? <div className={cssClassesPoster}>
        <BackgroundElementImg
            cssClassesDiv={cssClassesPoster}
            cssClassImg='poster-image'
            alt='Poster'
            src={posterSettings.finalImageURl} 
            srcFallback={posterSettings.imageUrl}
            fallbackInUse={fallbackInUse}
            setFallback={setFallback}
        /> 
    </div> : ''
)


export default BackgroundElementPoster